import React from 'react';
import {  Table, Grid, Row, Col, ProgressBar } from 'react-bootstrap';
import { getCrystalImage } from '../../api/ispyb.js';
import { commaSeparatedToNumberArray } from '../../helpers/NumericTransformationsHelper.js';
import ImageZoom from 'react-medium-image-zoom';
import PropTypes from 'prop-types';


export default class GridSquarePanel extends React.Component {
    
    getRow(key, value){
        return  <tr>
                     <td  xs={5} md={5} className="parameterKey" >{key}</td>
                    <td  xs={7} md={7} className="parameterValue" >{value}</td>
                </tr>;
        } 
    
   

    render() {          
        let _this = this
        let totalNumberOfMovies = 0;
        let noFrames = commaSeparatedToNumberArray(this.props.framesCount)[0];
        let dataCollectionIdArray = commaSeparatedToNumberArray(this.props.dataCollectionIdList);
        let startTimeList = this.props.startTimeList.split(',');
        let indexArray = Array.apply(null, {length: dataCollectionIdArray.length}).map(Number.call, Number);
        let statsArray = this.props.stats;
        let directoryArray = this.props.imageDirectoryList.split(',');
        let magnificationArray = commaSeparatedToNumberArray(this.props.magnificationList);
        let progressMotionCorArray = [];
        let progressCtfArray = [];
        let urlArray = [];
        if (statsArray.length == 0) {
            for (let i=0; i < dataCollectionIdArray.length; i++) {
                statsArray.push({'movieCount': ''});
                progressMotionCorArray.push('');
                progressCtfArray.push('');
                var url = "/sessions/em/proposal/:proposal/datacollection/:dataCollectionId/movies" 
                    .replace(':token', this.props.token)
                    .replace(':proposal', this.props.proposal)
                    .replace(':dataCollectionId', dataCollectionIdArray[i]);                  
                urlArray.push(url);
            }
        } else {
            for (let i = 0; i < statsArray.length; i++) {
                totalNumberOfMovies = totalNumberOfMovies + statsArray[i]['movieCount'];
                let progressMotionCor = statsArray[i]["motionCorrectionCount"] / statsArray[i]["movieCount"] * 100;
                let progressCtf = statsArray[i]["ctfCorrectionCount"] / statsArray[i]["movieCount"] * 100;
                progressMotionCorArray.push(Math.round(progressMotionCor * 10) / 10);
                progressCtfArray.push(Math.round(progressCtf * 10) / 10);
                var url = "/sessions/em/proposal/:proposal/datacollection/:dataCollectionId/movies" 
                    .replace(':token', this.props.token)
                    .replace(':proposal', this.props.proposal)
                    .replace(':dataCollectionId', dataCollectionIdArray[i]);                  
                urlArray.push(url);
            }
        }
        let now=50
        return  <div>                          
            <h3>Sample name : {this.props.sampleName}</h3>
            <Grid fluid style={{marginTop:'5px'}}>                   
                <Row>
                    <Col xs={12} sm={3} md={3} lg={3}>
                        <Table> 
                            <tbody>                    
                                {this.getRow("Total number of movies",  totalNumberOfMovies)}
                                {this.getRow("Magnification",  magnificationArray[0])}
                            </tbody>  
                        </Table>
                    </Col>
                    <Col xs={12} sm={3} md={3} lg={3}>
                        <Table> 
                            <tbody>                    
                                {this.getRow("Grid Squares",  this.props.gridSquaresCount)}
                                {this.getRow("# Frames",  noFrames)}
                            </tbody>  
                        </Table>
                    </Col>
                    <Col xs={12} sm={3} md={3} lg={3}>
                        <Table> 
                            <tbody>                    
                                {this.getRow("Voltage",  this.props.voltage + " V")}
                                {this.getRow("Spherical Aberation",  "2.7 mm")}
                            </tbody>  
                        </Table>
                    </Col>
                    <Col xs={12} sm={3} md={3} lg={3}>
                        <Table> 
                            <tbody>                    
                                {this.getRow("Amplitude Contrast)",  "10 %")}
                                {this.getRow("Sampling Rate",  this.props.samplingRate + " Å/pixel")}                    
                            </tbody>  
                        </Table>
                    </Col>
                </Row>
            </Grid>
            <Grid fluid>
                <Row>
                    {indexArray.reverse().map(index => {
                        return <Col xs={12} sm={4} md={4} lg={2} key={index}>                        
                        <Table>
                            <tbody>
                                <tr>
                                    <td><h4><a href={urlArray[index]} target="_blank">{startTimeList[index]}</a></h4></td>
                                </tr>
                                <tr>
                                    <td><ImageZoom thumbnail image={{ style: {width:'100%'}, src : getCrystalImage(
                                _this.props.user, _this.props.proposal, dataCollectionIdArray[index], 1)}} /> </td>
                                </tr>
                                <tr>
                                    <td className="parameterKey">N<sup>o</sup> movies: <span className="badge" style={{ marginLeft: '10px' }}>{statsArray[index]['movieCount']}</span></td>
                                </tr>
                                <tr>
                                    <td className="parameterKey"><ProgressBar now={progressMotionCorArray[index]} label={`Motion corr: ${progressMotionCorArray[index]}%`} /></td>
                                </tr>
                                <tr>
                                    <td className="parameterKey"><ProgressBar now={progressCtfArray[index]} label={`CTF: ${progressCtfArray[index]}%`} /></td>
                                </tr>
                            </tbody>
                        </Table></Col>
                    })}
                </Row>
            </Grid>
        </div>
            
    }
}

GridSquarePanel.propTypes = {
    token: PropTypes.string,
    proposal: PropTypes.string,
    sessionId: PropTypes.string,
  };


// WEBPACK FOOTER //
// ./src/components/Em/GridSquarePanel.js